export const BENEFICIAL_OWNER_LOADING_STATES = {
    GRID_LOADING: "GRID_LOADING",
    GRID_READY: "GRID_READY",
    CALCULATE_INFERRED_LOADING: "CALCULATE_INFERRED_LOADING",
    CALCULATE_INFERRED_READY: "CALCULATE_INFERRED_READY",
}

export const BENEFICIAL_OWNER_LOADING_STATES_MESSAGE_MAP = {
    [BENEFICIAL_OWNER_LOADING_STATES.GRID_LOADING]: "",
    [BENEFICIAL_OWNER_LOADING_STATES.CALCULATE_INFERRED_LOADING]: "",
}